(function () {
  'use strict';

  function init() {
    var section = document.querySelector('.section-services-grid');
    if (!section) return;

    var filterBtns = Array.prototype.slice.call(section.querySelectorAll('[data-filter]'));
    var cards      = Array.prototype.slice.call(section.querySelectorAll('.tg-sg__card'));

    /* ── CATEGORY FILTER ─────────────────────────────────────────────────── */
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.dataset.filter;

        filterBtns.forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.filter === cat);
        });

        cards.forEach(function (card) {
          card.style.display = (cat === 'all' || card.dataset.category === cat) ? '' : 'none';
        });
      });
    });

    /* ── TAP-TO-REVEAL ────────────────────────────────────────────────────
       Always bound, not gated behind a matchMedia('(hover: none)') check —
       that check can evaluate false on hybrid touch/mouse devices, which
       silently skipped attaching this listener and left the panel unable
       to open on tap at all, regardless of how many times it was tapped. */
    var activeCard = null;

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.tg-sg__card-panel-cta')) return;

        var alreadyOpen = card.classList.contains('is-active');

        if (activeCard && activeCard !== card) {
          activeCard.classList.remove('is-active');
        }

        card.classList.toggle('is-active', !alreadyOpen);
        activeCard = !alreadyOpen ? card : null;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
